import { tokens } from "../../../theme";
import { Box, Tooltip, Typography, useTheme } from "@mui/material";
import ActionButton from "./ActionButton";
import { releaseStyles } from "../styles";
import {
  actionText,
  formatLabelDate,
  isDestructiveAction,
  labelStatusText,
  pickForwardLabelAction,
} from "../summaryHelpers";
import { getHeaders } from "../../../utils/apiclient";

// One active label of a release. The forward action leads as a filled button
// and every other permitted action follows as an outlined one, in the order the
// API returns them — the summary has no overflow menu.
const ReleaseLabelRow = ({
  release,
  releaseLabel,
  app,
  showReleaseStatusDialog,
}) => {
  const theme = useTheme();
  const { statusColors, summaryTable } = releaseStyles(tokens(theme.paletteId));

  const { bg, fg, border } = statusColors(releaseLabel?.status);
  const actions = releaseLabel?.actionsAllowed || [];
  const forwardAction = pickForwardLabelAction(actions);
  const otherActions = actions.filter((action) => action !== forwardAction);
  const path = `/apps/${app}/releases/${release?.name}/release-labels/${releaseLabel?.name}`;

  const runAction = (action) =>
    showReleaseStatusDialog(
      `Perform action ${action} on release-label ${releaseLabel?.name}`,
      `/${release?.name}/release-labels/${releaseLabel?.name}`,
      { headers: { ...getHeaders(), Action: action } }
    );

  return (
    <Box sx={summaryTable.labelGridRow}>
      <Box sx={summaryTable.labelIdentity}>
        <Box sx={summaryTable.timelineCell}>
          <Box sx={summaryTable.timelineRule} />
          <Box sx={summaryTable.timelineDot(fg)} />
        </Box>

        <Typography sx={summaryTable.labelVersion}>
          {releaseLabel?.name}
        </Typography>

        <Box sx={summaryTable.pill(bg, border)}>
          <Typography component="span" sx={summaryTable.pillStatus(fg)}>
            {labelStatusText(releaseLabel?.status)}
          </Typography>
        </Box>
      </Box>

      <Tooltip title="Patch created date">
        <Typography sx={summaryTable.labelDate}>
          {formatLabelDate(releaseLabel?.dateCreated)}
        </Typography>
      </Tooltip>

      <Box sx={summaryTable.labelActions}>
        {actions.length ? (
          <>
            {forwardAction ? (
              <ActionButton
                action={forwardAction}
                path={path}
                text={actionText(forwardAction, releaseLabel?.status)}
                variant="outlined"
                sx={summaryTable.labelForwardButton}
                onClick={() => runAction(forwardAction)}
              />
            ) : null}
            {otherActions.map((action) => (
              <ActionButton
                key={action}
                action={action}
                path={path}
                text={actionText(action, releaseLabel?.status)}
                sx={summaryTable.labelActionButton(isDestructiveAction(action))}
                onClick={() => runAction(action)}
              />
            ))}
          </>
        ) : (
          <Typography sx={summaryTable.noActions}>No actions</Typography>
        )}
      </Box>
    </Box>
  );
};

export default ReleaseLabelRow;
